import { render, staticRenderFns } from "./ColumnEditDialog.vue?vue&type=template&id=30c0084e&"
import script from "./ColumnEditDialog.vue?vue&type=script&lang=js&"
export * from "./ColumnEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports